import { useEffect } from "react";
import { Flex } from "@chakra-ui/react";
import Menu from "./components/layout/Menu";
import Footer from "./components/layout/footer/Footer";
import { Route, Routes, useLocation } from "react-router-dom";
import AllEventsPage from "./pages/AllEvents/AllEventsPage";
import EventDetailPage from "./pages/EventDetailPage/EventDetailPage";
import ResultsPage from "./pages/ResultsPage/ResultsPage";
import Contact from "./components/layout/footer/Contact";
import PrivacyPolicy from "./components/layout/footer/PrivacyPolicy";
import LegalArchive from "./components/legal/LegalArchive";
import Organizers from "./components/layout/footer/Organizers";
import About from "./components/layout/footer/About";
import Regulations from "./components/layout/footer/Regulations";
import Cookie from "./components/layout/footer/Cookie";
import HowItWorks from "./components/layout/footer/HowItWorks";
import FAQ from "./components/layout/footer/FAQ";
import DataProcessing from "./components/layout/footer/DataProcessing";
import PriceList from "./components/layout/footer/PriceList";
import MyCart from "./components/cart/MyCart";
import OrderFlow from "./components/cart/OrderFlow";
import PaymentSuccessPage from "./pages/Payment/PaymentSuccessPage";
import PaymentErrorPage from "./pages/Payment/PaymentErrorPage";
import TicketDownloadPage from "./pages/TicketDownloadPage/TicketDownloadPage";

function App() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const isWhiteBackground = /order|payment/.test(location.pathname);

    return (
        <Flex minH={'100vh'}
            flexDirection={'column'}
            alignItems={'center'}>
            <Menu />
            <Flex bg={isWhiteBackground ? 'surface.card' : 'surface.page'} w={'100%'} justifyContent={'center'} pb={{ base: '16px', sm: '0px' }} flexGrow={1}>
                <Flex w={'100%'} alignItems="flex-start" justifyContent="center">
                    <Routes>
                        <Route path={"/"} element={<AllEventsPage />} />
                        <Route path={"/event/:id"} element={<EventDetailPage />} />
                        <Route path={"/results"} element={<ResultsPage />} />
                        <Route path={"/contact"} element={<Contact />} />
                        <Route path={"/organizers"} element={<Organizers />} />
                        <Route path={"/about"} element={<About />} />
                        <Route path={"/regulations"} element={<Regulations />} />
                        <Route path={"/cookie"} element={<Cookie />} />
                        <Route path={"/cookie/v1.0"} element={<Cookie archivedVersion="1.0" />} />
                        <Route path={"/privacy-policy"} element={<PrivacyPolicy />} />
                        <Route path={"/privacy-policy/v1.0"} element={<PrivacyPolicy archivedVersion="1.0" />} />
                        <Route path={"/legal-archive"} element={<LegalArchive />} />
                        <Route path={"/how-it-works"} element={<HowItWorks />} />
                        <Route path={"/faq"} element={<FAQ />} />
                        <Route path={"/data-processing"} element={<DataProcessing />} />
                        <Route path={"/price-list"} element={<PriceList />} />
                        <Route path={"/cart"} element={<MyCart />} />
                        <Route path={"/order"} element={<OrderFlow />} />
                        <Route path={"/payments/:id/success"} element={<PaymentSuccessPage />} />
                        <Route path={"/payments/:id/error"} element={<PaymentErrorPage />} />
                        <Route path={"/tickets/:id/download"} element={<TicketDownloadPage />} />
                    </Routes>
                </Flex>
            </Flex>
            <Footer />
        </Flex>
    );
}

export default App;
